import {useEffect} from 'react';

// docs: https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#product-impressions

type Props = {
  currencyCode: string;
  name: string;
  price: string;
};

export default function GtmProductImpression({
  currencyCode,
  name,
  price,
}: Props) {
  useEffect(() => {
    window.dataLayer.push({ecommerce: null}); // Clear the previous ecommerce object.
    window.dataLayer.push({
      ecommerce: {
        currencyCode,
        impressions: [
          {
            name,
            price,
            brand: 'Goodnature',
            position: 1,
          },
        ],
      },
    });
  });

  return <></>;
}
